<template>
    <div class="container-refundManage">
        <div class="title">
            <div class="title-text">
                <img src="../../components/appSidebar/imgs/navigation_icon_goods.png" class="title-logo"/>
                <span >退款/售后管理</span>
            </div>
            <!-- <el-button type="primary" size="small" class="add-button">添加</el-button> -->
        </div>
		<div class="query">
			<div class="fl">
				<label class="query-key">申请时间</label>
				<el-date-picker
					v-model="timeVal"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期">
					</el-date-picker>
			</div>
            <div class="fl">
                <label class="query-key">订单号</label>
                <el-input v-model="form.orderId" placeholder="请输入内容" style="width:200px;"></el-input>
            </div>
            <div class="fl" v-if="$developerType == 2">
                <label class="query-key">店铺ID</label>
                <el-input v-model="form.poiId" placeholder="请输入内容" style="width:200px;"></el-input>
            </div>
		</div>
        <div class="query">
            <div class="fl">
				<label class="query-key">商品名称</label>
				<el-input v-model="form.dealTitle" placeholder="请输入内容" style="width:200px;"></el-input>
			</div>
			<div class="fl">
				<label class="query-key">订单状态</label>
				<el-select v-model="form.subStatus" placeholder="请选择" style="width:200px;">
					<el-option
					v-for="item in statusList"
					:key="item.value"
					:label="item.label"
					:value="item.value">
					</el-option>
                </el-select>
			</div>
			<div class="fl">
				<label class="query-key">退款/售后</label>
				<el-select v-model="form.afterSalesStatus" placeholder="请选择" style="width:200px;">
					<el-option
					v-for="item in afterSalesStatusList"
					:key="item.value"
					:label="$developerType == 2 ? item.userlabel : item.businessLabel"
					:value="item.value">
					</el-option>
                </el-select>
			</div>

            <el-button @click="initList" type="primary">查询</el-button>
        </div>
        <div class="query">
            
        </div>
        <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                prop="orderId"
                label="订单号">
            </el-table-column>
            <el-table-column
                prop="goodsPicUrl"
                label="商品图片">
                <template slot-scope="scope">
                    <el-image
                        class="goods-picurl"
                        v-if="scope.row.goodsPicUrl"
                        :src="scope.row.goodsPicUrl"
                        :preview-src-list="[scope.row.goodsPicUrl]"
                    >
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column
                prop="goodsTitle"
                label="商品名称">
            </el-table-column>
            <el-table-column
                width="120"
                prop="goodsPrice"
                label="单价">
            </el-table-column>
			<el-table-column
                prop="goodsCount"
                label="数量"
                width="96">
            </el-table-column>
            <el-table-column
                prop="orderSubStatusText"
                label="订单状态">
            </el-table-column>
            
            <el-table-column
                prop="afterSalesStatusDesc"
                label="退款/售后">
            </el-table-column>
            <el-table-column
                prop="refundReason"
                label="退款原因">
            </el-table-column>
			<el-table-column
                prop="refundSubmitTime"
                label="申请时间">
            </el-table-column>
			<el-table-column
                prop="refundMoney"
                label="申请金额">
            </el-table-column>
			<el-table-column
                prop="actualRefundMoney"
                width="100"
                label="退款金额">
            </el-table-column>
            <el-table-column
                width="150"
                label="操作">
                <template slot-scope="scope">
                    <div style="margin-bottom:4px;">
                        <el-button
                            size="mini"
                            type="primary"
                            @click="goToRefundDetail(scope.row.afterSalesId, scope.row.orderId)">退款/售后详情
                        </el-button>
                    </div>
                    <div>
                        <el-button
                            size="mini"
                            @click="showDetail(scope.row.orderId)">订单详情
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagation-wrapper">
            <span class="pagation-text">共{{totalPage}}页/共{{totalCount}}条</span>
            <el-pagination
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :total="totalCount">
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    mounted() {
        // 运营端为2，商家端为3
        this.initList();
    },
    data() {
        return {
            timeVal: '',
            statusList: [{
                label: '全部',
                value: null
            }, {
                label: '待付款',
                value: 1
            },
            {
                label: '未发货',
                value: 2
            },
            {
                label: '配送中',
                value: 3
            }, {
                label: '退款中',
                value: 4
            },
            {
                label: '已退款',
                value: 5
            },
            {
                label: '退款失败',
                value: 6
            }, {
                label: '已取消',
                value: 7
            },
            {
                label: '已签收',
                value: 8
            }],
            afterSalesStatusList: [
                {
                    userlabel: '全部',
                    value: null,
                    businessLabel: '全部'
                },
                {
                    userlabel: '申请提交，待商家处理',
                    value: 1,
                    businessLabel: '买家已申请售后，待商家处理'
                },
                {
                    userlabel: '商家拒绝退款申请',
                    value: 2,
                    businessLabel: '审核拒绝'
                },
                {
                    userlabel: '请退货给商家',
                    value: 3,
                    businessLabel: '已同意退货，待买家发货'
                },
                {
                    userlabel: '待商家收货',
                    value: 4,
                    businessLabel: '请收货并退款'
                },
                {
                    userlabel: '商家已收货，待确认退款',
                    value: 5,
                    businessLabel: '已收货，请确认退款'
                },
                {
                    userlabel: '商家同意，退款处理中',
                    value: 6,
                    businessLabel: '已确认退款，退款处理中'
                },
                {
                    userlabel: '退款成功',
                    value: 7,
                    businessLabel: '退款成功'
                },
                {
                    userlabel: '退款失败',
                    value: 8,
                    businessLabel: '退款失败'
                },
                {
                    userlabel: '退货退款关闭',
                    value: 9,
                    businessLabel: '退货退款关闭'
                }
            ],
            tableData: [
            // {
            //     "goodsPicUrl": "https://bj.bcebos.com/v1/tspd-platform/984086082/7481dafe962b3425e3daef978e68be69.jpeg",
            //     "afterSalesId": 1,
            //     "afterSalesType":  1,
            //     "poiId": 1234,
            //     "orderId": 81840464686082,
            //     "goodsImageUrl": "xxx.png",
            //     "goodsTitle":"梵高装饰画《向日葵》名作",
            //     "goodsPrice": 100,
            //     "goodsCount": 2,
            //     "orderSubStatus": 2,
            //     "afterSalesStatus": 5,
            //     "refundReason": "多拍、错拍、不想要",
            //     "createTime": "2020-02-17 19:30:39",
            //     "refundMoney": 200,
            //     "actualRefundMoney":0
            // },
            // {
            //     "goodsPicUrl": "https://bj.bcebos.com/v1/tspd-platform/984086082/7481dafe962b3425e3daef978e68be69.jpeg",
            //     "afterSalesType": 2,
            //     "afterSalesId": 2,
            //     "poiId": 1234,
            //     "orderId": 81840464686082,
            //     "goodsImageUrl": "xxx.png",
            //     "goodsTitle":"梵高装饰画《向日葵》名作",
            //     "goodsPrice": 100,
            //     "goodsCount": 2,
            //     "orderSubStatus": 3,
            //     "afterSalesStatus": 5,
            //     "refundReason": "多拍、错拍、不想要",
            //     "refundSubmitTime": "2020-02-17 19:30:39",
            //     "refundMoney": 200,
            //     "actualRefundMoney":0
            // }
            ],
            categoryNum: 1,
            form: {
                poiId: '', //	Long	是	门店ID	
                orderId: '', //	Long	否	订单ID	
                dealTitle: '',//	String	否	商品名称	
                subStatus: null, //	Integer	否	订单状态	
                afterSalesStatus: null, //	Integer	否	退款/售后状态	
                startTime: '', //	起始时间	
                endTime: '', // 结束时间	
                currPage: 1,
                pageSize: 10
            },
            totalPage: 0,
            totalCount: 0
        };
    },
    methods: {
        handleCurrentChange(val) {
            this.form.currPage = val;
            this.initList();
        },
        initList() {
            let param = this.form;
            if (this.timeVal) {
                param.startTime = this.timeVal[0] && this.timeVal[0].getTime() || '';
                param.endTime = this.timeVal[0] && this.timeVal[1].getTime() || '';
            }
            // 如果开始时间等于结束时间
            if (param.startTime === param.endTime && typeof(param.startTime) === 'number') {
                param.endTime = param.startTime + 24 * 60 * 60 * 1000 - 1;
            }
            let url;
            if (+this.$developerType === 2) {
                url = 'getItemListByPlatformId';
            }
            else {
                url = 'afterSalesList';
            }
            this.$api[url](param).then(res => {
                if (res.code === 0) {
                    this.tableData = res.data.merchantAfterSalesList;
                    this.totalPage = res.data.totalPages;
                    this.totalCount = res.data.totalElements;
                    this.tableData.forEach(item => {
                        let temparr = this.afterSalesStatusList.filter(item2 => +item2.value === +item.afterSalesStatus);
                        if (item.afterSalesType === 1) {
                            item.afterSalesStatusDesc = temparr[0] && temparr[0].userlabel || '';
                        } else {
                            item.afterSalesStatusDesc = temparr[0] && temparr[0].businessLabel || '';
                        }
                        let temparr2 = this.statusList.filter(item2 => +item2.value === +item.subStatus);
                        item.orderSubStatusText = temparr2[0] && temparr2[0].label || '';
                    });
                }
                else {
                    this.$message.error(res.msg);
                }
            }).catch(e => {
                // 接口失败做的操作
                console.log(e);
            });
        },
        showDetail(data) {
            this.$router.push({path: '/orderDetail', query: {
                orderId: data
            }});
        },
        handleView(index, data) {
            this.dialogdDetailVisible = true;
            this.detail = data;
        },
        goToRefundDetail(id, orderId) {
            this.$router.push({path: '/refundManageDetail', query: {
                afterSalesId: id,
                orderId: orderId
            }});
        }
    }
};
</script>
<style lang="less">
.container-refundManage {
    .goods-picurl {
        margin-right: 4px;
        background-size: contain;
        height: 80px;
        width: 80px;
    }
    .el-date-editor .el-range-separator {
        position: relative;
        left: -4px;
    }
	// height: 2000px;
    .query {
        overflow: hidden;
        margin-bottom: 20px;
    }
	.query-key {
		display: inline-block;
		width: 70px;
	}
	.fl {
		float: left;
		margin-right: 40px;
	}
    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border: solid 1px #EBEEF5;
        color: #303133;
        font-size: 20px;
        padding: 20px 15px;
        border-radius: 4px;
        margin: 0 0 20px 0;
        .title-text {
            display: flex;
            align-items: center;
            .title-logo {
                width: 20px;
                margin-right: 12px;
            }
        }
        .add-button {
            float: right;
        }
    }
    .detail {
        label {
            display: inline-block;
            width: 100px;
        }
    }
    .standardName {
		display: inline-block;
        width: 80px;
        margin-bottom: 10px;
    }
    .standardTag {
        margin-right: 20px;
        margin-bottom: 10px;
    }
    .standardValue {
        display: inline;
    }
    .add-standardName {
        display: inline-block;
        margin-bottom: 6px;
	}
    .dele-color {
        color:#ff5a5f;
    }
    .img-upload-tip {
        color: #606266;
    }
}

.pagation-wrapper {
    background: #ffffff;
    display: flex;
    align-items: center;
    float: right;
    margin: 20px;
    .pagation-text {
        margin-right: 10px;
        font-weight: 400;
        color: #606266;
    }
}

.btnline {
    margin-bottom: 2px;
}
.cl {
    overflow: hidden;
}
.statusview {
    position: relative;
    margin-left: 0px;
    margin-top: 4px;
}
</style>